export default __webpack_public_path__ + "static/media/facebook.86e96367.png";